export default "__VITE_ASSET__c81f6ac3__"